import React from "react";
import EmptyBox from "./extras/EmptyBox";
import { ReactComponent as EmptyNotesSvg } from "../../assets/images/cm-empty-notes.svg";

const NotesSection = () => {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <span className="flex flex-col items-center">
        {/* <EmptyBox width={350} height={350} /> */}
        <EmptyNotesSvg />
      </span>
    </div>
  );
};

export default NotesSection;
